export enum DropdownButtonStyle {
    ChevronOnly,
    Label,
    Result,
}
